/**
 * Sammelsendung (Task 4b): die Reichweite eines Dokuments haengt am DOKUMENT, nicht am Typ - die
 * Vorbelegung aus `reichweiteVorgabe` (`lib/dokumentReichweite.ts`) ist deshalb nur ein Vorschlag,
 * den der Hochladende hier umstellen kann. Der wichtigste Fall: `bl_hawbl` ist als "bestellung"
 * vorbelegt (House-B/Ls sind der haeufigere Fall), ein Master-B/L stellt hier auf "sendung" um.
 *
 * Unkontrolliert (`defaultChecked`, kein `useState`): beide Optionsfelder teilen sich einen
 * `name`, die gegenseitige Ausschliesslichkeit uebernimmt der Browser selbst. `onChange` liefert
 * NUR die getroffene Wahl - kein `value`-Prop, keine Rueckwaertsschleife, der Aufrufer haelt den
 * aktuellen Stand (siehe `DokumenteTab.tsx`).
 *
 * Ohne `dsvShipmentNo` gibt es keine Sendung, an die sich haengen liesse - die zweite Option
 * entfaellt vollstaendig (nicht nur deaktiviert), und die Vorbelegung faellt zwingend auf
 * `"bestellung"` zurueck (der Rueckfall aus Task 4, `backend/src/documents/repository.ts`
 * `legeVersionAn` faellt fuer denselben Fall serverseitig ebenfalls auf `"bestellung"` zurueck).
 */
import { reichweiteVorgabe } from "../../../lib/dokumentReichweite.ts";
import type { Reichweite } from "../../../lib/dokumentReichweite.ts";

export interface ReichweiteAuswahlProps {
  docType: string;
  /** `Order.dsvShipmentNo` - `null`/`undefined`, solange die Bestellung an keiner Sendung haengt. */
  dsvShipmentNo?: string | null;
  /** Die Gruppenwahl ist nur fuer aktive Hub-interne Bestellgruppen eine moegliche UI-Option. */
  orderGroupId?: string | null;
  orderGroupMemberCount?: number | null;
  orderGroupStatus?: "active" | "dissolved" | null;
  onChange: (reichweite: Reichweite) => void;
}

export function ReichweiteAuswahl({
  docType,
  dsvShipmentNo,
  orderGroupId,
  orderGroupMemberCount,
  orderGroupStatus,
  onChange,
}: ReichweiteAuswahlProps) {
  const hatSendung = Boolean(dsvShipmentNo);
  const hatAktiveGruppe = Boolean(orderGroupId) && orderGroupStatus === "active";
  const vorbelegung: Reichweite = hatSendung ? reichweiteVorgabe(docType) : "bestellung";
  const name = `reichweite-${docType}`;

  return (
    <fieldset className="reichweite-auswahl">
      <legend>Gilt für</legend>
      <label>
        <input
          type="radio"
          name={name}
          value="bestellung"
          defaultChecked={vorbelegung === "bestellung"}
          onChange={() => onChange("bestellung")}
        />
        Nur diese Bestellung
      </label>
      {hatAktiveGruppe ? (
        <label>
          <input type="radio" name={name} value="gruppe" onChange={() => onChange("gruppe")} />
          Die ganze Bestellgruppe
          {typeof orderGroupMemberCount === "number" ? ` (${orderGroupMemberCount} Bestellungen)` : ""}
        </label>
      ) : null}
      {hatSendung ? (
        <label>
          <input
            type="radio"
            name={name}
            value="sendung"
            defaultChecked={vorbelegung === "sendung"}
            onChange={() => onChange("sendung")}
          />
          Die ganze Sendung ({dsvShipmentNo})
        </label>
      ) : null}
    </fieldset>
  );
}
